// extracted by mini-css-extract-plugin
export default {"body":"style_body__4S+wz","title":"style_title__hNmAw","select":"style_select__n1zZK","footer":"style_footer__mbJT0","description":"style_description__b1E4a"};